"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayerTypes = void 0;
exports.LayerTypes = ['content', 'focus', 'interaction'];
//# sourceMappingURL=LayerTypes.js.map